import { BehaviorSubject } from "rxjs";

/**
This is a shared STATE
 */
export enum AuthSessionStatus{
    NONE=0,
    SUUCCESS,
    FAIL
}

/**
WEB3 specific
testMessage is used as a console output message only
 */
export interface AuthSessionRX{
    testMessage:string
    authSessionStatus:AuthSessionStatus
    userProfileRef:string
    email:string
    token:string
}


var initialWeb3PanelStates:AuthSessionRX={
    testMessage:'Initial Panel States Applied',
    authSessionStatus:AuthSessionStatus.NONE,
    userProfileRef:'',
    email:'',
    token:''
}

/**
The subject is converted to an Observable when a subscriber pre-filters the pipe.
In order to set state back into this, a subject would need to be subscribed raw and a next call made
 */
export const authSessionState$ = new BehaviorSubject<AuthSessionRX>(initialWeb3PanelStates);

authSessionState$.subscribe(
    (data)=> {
        testWeb3StateInstruction(data);
    }
)

function testWeb3StateInstruction(output:AuthSessionRX){
    console.warn("Auth Sessuin State output => " +  output.testMessage);
}





export async function updateAuthSessionState(
    authSessionStatus:AuthSessionStatus,
    userProfileRef:string,
    email:string,
    token:string,
):Promise<AuthSessionRX>{
    var returnState:AuthSessionRX = {
        testMessage:'Updated Web3 Presentation State => ' + AuthSessionStatus[authSessionStatus].toString(),
        authSessionStatus:authSessionStatus,
        userProfileRef:userProfileRef,
        email:email,
        token:token
    }

    authSessionState$.next(returnState);

    return returnState;
}



